module.exports = __webpack_public_path__ + "media/src/assets/images/case-manager-d7387a48dd3432de3428959e323741da.png";